<template>
  <div>
    <v-col lg="12">
      <s-crud 
        add 
        edit 
        height="auto"
        :filter="filter"
        remove 
        title="SOLICITUD DE REQUERIMIENTOS DE TI" 
        :config="config"    
        @save="save($event)" 
        @addEvent="clearForm()"
        @rowSelected="rowSelected($event)" 
        searchInput
        ref="crud"
      >
        <template v-slot:filter>
          <v-container>
            <v-row>
              <v-col cols="12" sm="4">
                <s-text
                  label="Título de Requerimiento"
                  v-model="filter.ReqTitle"
                ></s-text>
              </v-col>
              <v-col cols="12" sm="4">
                <s-select-definition
                  label="Tipo"
                  :def="1720"
                  v-model="filter.ReqType"
                  clearable
                ></s-select-definition>
              </v-col>
              <v-col cols="12" sm="4">
                <s-select-definition
                  label="Estado"
                  :def="1721"
                  v-model="filter.ReqStatus"
                  clearable
                ></s-select-definition>
              </v-col>
            </v-row>
          </v-container>
        </template>

        <template scope="props">
          <v-container>
            <v-row justify="center">
              <v-col cols="12" sm="6" md="4">
                <s-text label="Usuario Solicitante" v-model="props.item.RequesterName" readonly disabled></s-text>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <s-text label="Correo de Contacto" v-model="props.item.ReqEmail"></s-text>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <s-date label="Fecha Solicitud" type="datetime" v-model="props.item.ReqDate" readonly disabled></s-date>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12" sm="6" md="4">
                <s-text label="Gerencia" v-model="props.item.GerenciaName" readonly disabled></s-text>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <s-text label="Área" v-model="props.item.AreaName" readonly disabled></s-text>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <div style="padding-top:-2px;margin-top:-2px;">
                  <v-label class="d-flex align-center">
                    <b>Sistema o Proceso Afectado</b>
                    <v-tooltip bottom max-width="300">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="ml-1"
                          v-bind="attrs"
                          v-on="on"
                          color="grey darken-1"
                        >
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                      <span>Indique el módulo, sistema o proceso específico donde ocurre la necesidad (ej: Facturación, SAP, Módulo de Asistencia).</span>
                    </v-tooltip>
                  </v-label>
                  <v-text-field
                    v-model="props.item.ReqSystemProcess"
                    outlined
                    dense
                    hide-details="auto"
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12" sm="6" md="6">
                <s-select-definition label="Tipo de Requerimiento" :def="1720" v-model="props.item.ReqType" clearable></s-select-definition>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <s-text label="Título del Requerimiento" v-model="props.item.ReqTitle"></s-text>
              </v-col>
              <!-- 
              <v-col cols="12" sm="6" md="4">
                <s-select
                  label="Estado"
                  v-model="props.item.ReqStatus"
                  :items="statusItems"
                  item-value="DedValue"
                  item-text="DedDescription"
                  clearable
                  :disabled="props.item.ReqID == 0"
                ></s-select>
              </v-col>
              -->
            </v-row>

            <v-row justify="center">
              <v-col cols="12" md="6">
                <div class="s-textarea-wrapper">
                  <v-label class="textarea-label d-flex align-center">
                    <b>Problema Actual / Necesidad</b>
                    <v-tooltip bottom max-width="300">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="ml-1"
                          v-bind="attrs"
                          v-on="on"
                          color="grey darken-1"
                        >
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                      <span>Describa cómo realiza actualmente el proceso, su frecuencia y las principales dificultades.</span>
                    </v-tooltip>
                  </v-label>
                  <v-textarea
                    v-model="props.item.ReqCurrentProblem"
                    outlined
                    dense
                    auto-grow
                    rows="3"
                    class="s-textarea-field resizable"
                  ></v-textarea>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="s-textarea-wrapper">
                  <v-label class="textarea-label d-flex align-center">
                    <b>Resultado Esperado</b>
                    <v-tooltip bottom max-width="300">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="ml-1"
                          v-bind="attrs"
                          v-on="on"
                          color="grey darken-1"
                        >
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                      <span>Describa qué espera que realice el sistema o cuál es la solución deseada.</span>
                    </v-tooltip>
                  </v-label>
                  <v-textarea
                    v-model="props.item.ReqExpectedResult"
                    outlined
                    dense
                    auto-grow
                    rows="3"
                    class="s-textarea-field resizable"
                  ></v-textarea>
                </div>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12" md="8">
                <div class="s-textarea-wrapper">
                  <v-label class="textarea-label d-flex align-center">
                    <b>Impacto / Beneficio del Cambio</b>
                    <v-tooltip bottom max-width="300">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          class="ml-1"
                          v-bind="attrs"
                          v-on="on"
                          color="grey darken-1"
                        >
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                      <span>Indique tiempo empleado, errores, costos o beneficios esperados. Incluya cantidades aproximadas cuando sea posible.</span>
                    </v-tooltip>
                  </v-label>
                  <v-textarea
                    v-model="props.item.ReqImpact"
                    outlined
                    dense
                    auto-grow
                    rows="3"
                    class="s-textarea-field resizable"
                  ></v-textarea>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <s-textarea
                  label="N° Usuarios y Áreas Involucradas"
                  v-model="props.item.ReqAffectedUsers"
                  placeholder="Ej: 15 usuarios (Contabilidad, Finanzas)"
                  clearable
                ></s-textarea>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12" sm="5" md="4">
                <s-date label="Fecha Requerida de Entrega" type="date" v-model="props.item.ReqRequiredDate" clearable></s-date>
              </v-col>
              <v-col cols="12" sm="7" md="8">
                <s-text
                  label="Motivo de Fecha Requerida"
                  v-model="props.item.ReqRequiredDateReason"
                  placeholder="Ej: Normativa legal, auditoría externa, campaña o vencimiento contractual."
                  clearable
                ></s-text>
              </v-col>
            </v-row>

            <!-- Bloque Nuevo: Cumplimiento / Auditoría -->
            <v-row justify="center">
              <v-col cols="12" :md="props.item.ReqIsCompliance ? 5 : 12">
                <div class="s-textarea-wrapper">
                  <v-label class="textarea-label d-flex align-center">
                    <b>¿Obligación Legal, Auditoría o Control Obligatorio?</b>
                    <v-tooltip bottom max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon small class="ml-1" v-bind="attrs" v-on="on" color="grey darken-1">
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                      <span>¿Este requerimiento responde a una obligación legal, auditoría o control obligatorio? Si responde Sí, solicite el detalle normativo.</span>
                    </v-tooltip>
                  </v-label>
                  <v-radio-group v-model="props.item.ReqIsCompliance" row hide-details class="mt-2">
                    <v-radio label="Sí" :value="true" color="primary"></v-radio>
                    <v-radio label="No" :value="false" color="grey darken-1"></v-radio>
                  </v-radio-group>
                </div>
              </v-col>
              <v-col cols="12" md="7" v-if="props.item.ReqIsCompliance">
                <div class="s-textarea-wrapper">
                  <v-label class="textarea-label d-flex align-center">
                    <b>Detalle de Obligación Legal / Auditoría *</b>
                  </v-label>
                  <v-textarea
                    v-model="props.item.ReqComplianceDetail"
                    outlined
                    dense
                    auto-grow
                    rows="2"
                    placeholder="Especifique la norma, ente regulador (SUNAT, SBS, etc.), auditoría o control que lo exige..."
                    class="s-textarea-field resizable"
                  ></v-textarea>
                </div>
              </v-col>
            </v-row>

            <!-- Bloque Nuevo: Consecuencia de No Implementar -->
            <v-row justify="center">
              <v-col cols="12">
                <div class="s-textarea-wrapper">
                  <v-label class="textarea-label d-flex align-center">
                    <b>Consecuencia de No Implementar</b>
                    <v-tooltip bottom max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon small class="ml-1" v-bind="attrs" v-on="on" color="grey darken-1">
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                      <span>¿Qué sucede si este requerimiento no es atendido o se posterga? Describa riesgos de continuidad, sanciones, multas o pérdidas operativas.</span>
                    </v-tooltip>
                  </v-label>
                  <v-textarea
                    v-model="props.item.ReqNonImplementationConsequence"
                    outlined
                    dense
                    auto-grow
                    rows="2"
                    placeholder="¿Qué sucede si este requerimiento no es atendido o se posterga? Describa contingencias, multas o riesgos operativos..."
                    class="s-textarea-field resizable"
                  ></v-textarea>
                </div>
              </v-col>
            </v-row>

            <v-row align="center" justify="start">
              <v-col cols="12" sm="6" md="4">
                <v-file-input
                  label="Archivo de Evidencia (PDF, ZIP, Imágenes - Máx 10MB)"
                  v-model="evidenceFile"
                  accept=".zip,.pdf,.png,.jpg,.jpeg"
                  hide-details
                  prepend-icon="mdi-paperclip"
                  @change="validateFile"
                ></v-file-input>
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <v-btn
                  v-if="props.item.ReqEvidencePath"
                  color="success"
                  class="mt-2"
                  block
                  @click="openFile(props.item.ReqEvidencePath)"
                >
                  <v-icon left>mdi-download</v-icon>
                  Descargar
                </v-btn>
              </v-col>
              <v-col cols="12" sm="4" md="6">
                <v-text-field
                  label="Url o Enlace (Opcional)"
                  v-model="props.item.ReqEvidenceLink"
                  placeholder="http://172.16.1.8:8182/querymanager/querys"
                  hint="Ej: Enlace al sistema o ticket relacionado"
                  persistent-hint
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </template>

        <!-- Custom Slots for Data Table Columns -->
        <template v-slot:item.ReqDate="{ item }">
          <span>{{ formatDate(item.ReqDate) }}</span>
        </template>

        <template v-slot:item.ReqRequiredDate="{ item }">
          <div v-if="item.ReqRequiredDate" class="d-inline-flex align-center">
            <span>{{ formatDate(item.ReqRequiredDate) }}</span>
            <v-tooltip bottom v-if="item.ReqRequiredDateReason" max-width="320">
              <template v-slot:activator="{ on, attrs }">
                <v-icon x-small color="primary" class="ml-1" v-bind="attrs" v-on="on">
                  mdi-information
                </v-icon>
              </template>
              <span><b>Motivo:</b> {{ item.ReqRequiredDateReason }}</span>
            </v-tooltip>
          </div>
          <span v-else>-</span>
        </template>

        <template v-slot:item.InitialStatus="{ item }">
          <v-chip small color="blue-grey lighten-4" class="font-weight-medium text--darken-2">
            Nuevo
          </v-chip>
        </template>

        <template v-slot:item.ReqStatusName="{ item }">
          <v-chip
            small
            :color="getStatusColor(item.ReqStatus)"
            dark
            class="font-weight-bold"
          >
            {{ item.ReqStatusName || 'Nuevo' }}
          </v-chip>
        </template>

        <template v-slot:item.DaysOld="{ item }">
          <v-chip
            small
            outlined
            :color="getDaysOldColor(item.ReqDate)"
            class="font-weight-bold"
          >
            {{ calculateDaysOld(item.ReqDate) }} d
          </v-chip>
        </template>

        <template v-slot:item.ReqEvidencePath="{ item }">
          <v-btn v-if="item.ReqEvidencePath" color="success" icon x-small @click="openFile(item.ReqEvidencePath)">
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </template>

        <!-- SCrud Fallback Row Slots -->
        <template v-slot:ReqDate="{ row }">
          <span>{{ formatDate(row.ReqDate) }}</span>
        </template>

        <template v-slot:ReqRequiredDate="{ row }">
          <div v-if="row.ReqRequiredDate" class="d-inline-flex align-center">
            <span>{{ formatDate(row.ReqRequiredDate) }}</span>
            <v-tooltip bottom v-if="row.ReqRequiredDateReason" max-width="320">
              <template v-slot:activator="{ on, attrs }">
                <v-icon x-small color="primary" class="ml-1" v-bind="attrs" v-on="on">
                  mdi-information
                </v-icon>
              </template>
              <span><b>Motivo:</b> {{ row.ReqRequiredDateReason }}</span>
            </v-tooltip>
          </div>
          <span v-else>-</span>
        </template>

        <template v-slot:InitialStatus="{ row }">
          <v-chip small color="blue-grey lighten-4" class="font-weight-medium text--darken-2">
            Nuevo
          </v-chip>
        </template>

        <template v-slot:ReqStatusName="{ row }">
          <v-chip
            small
            :color="getStatusColor(row.ReqStatus)"
            dark
            class="font-weight-bold"
          >
            {{ row.ReqStatusName || 'Nuevo' }}
          </v-chip>
        </template>

        <template v-slot:DaysOld="{ row }">
          <v-chip
            small
            outlined
            :color="getDaysOldColor(row.ReqDate)"
            class="font-weight-bold"
          >
            {{ calculateDaysOld(row.ReqDate) }} d
          </v-chip>
        </template>

        <template v-slot:ReqEvidencePath="{ row }">
          <v-btn v-if="row.ReqEvidencePath" color="success" icon x-small @click="openFile(row.ReqEvidencePath)">
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </template>

      </s-crud>
    </v-col>
  </div>
</template>

<script>
import _sRequirementService from '@/services/InformationTechnology/TicRequirementService.js';
import _sGeneral from "@/services/HelperService.js";
import sTextarea from '../../../components/Utils/sTextarea.vue';
import _sDefinition from "@/services/General/DefinitionService.js";
import { statusColor } from './statusColors.js';

export default {
  components: { sTextarea },
  data() {
    return {
      selected: {},
      evidenceFile: null,
      statusItems: [],
      filter: {
        ReqTitle: "",
        ReqType: null,
        ReqStatus: null
      },
      config: {
        model: {
          ReqID: "ID",
          ReqDate: "datetime",
          ReqAffectedUsers: "string",
          ReqRequiredDate: "date",
          ReqRequiredDateReason: "string",
          ReqIsCompliance: "boolean",
          ReqComplianceDetail: "string",
          ReqNonImplementationConsequence: "string",
          ReqEvidencePath: "FilePathDownload",
          ReqEvidenceLink: "string",
          DaysOld: "string",
          InitialStatus: "string"
        },
        service: _sRequirementService,
        headers: [
          { text: "ID Solicitud", value: "ReqCode", width: "130px" },
          { text: "Fecha Solicitud", value: "ReqDate", width: "140px" },
          { text: "Solicitante", value: "RequesterName", width: "180px" },
          { text: "Correo", value: "ReqEmail", width: "180px" },
          { text: "Gerencia", value: "GerenciaName", width: "150px" },
          { text: "Área", value: "AreaName", width: "150px" },
          { text: "Sistema / Proceso", value: "ReqSystemProcess", width: "160px" },
          { text: "Tipo Solicitud", value: "ReqTypeName", width: "150px" },
          { text: "Título", value: "ReqTitle", width: "200px" },
          { text: "N° Usuarios / Áreas", value: "ReqAffectedUsers", width: "180px" },
          { text: "Fecha Requerida", value: "ReqRequiredDate", width: "140px" },
          { text: "Motivo Fecha", value: "ReqRequiredDateReason", width: "200px" },
          { text: "Estado Inicial", value: "InitialStatus", align: "center", width: "130px" },
          { text: "Estado Actual", value: "ReqStatusName", align: "center", width: "160px" },
          { text: "Antigüedad (días)", value: "DaysOld", align: "center", width: "140px" },
          { text: "Evidencia", value: "ReqEvidencePath", align: "center", width: "100px", sortable: false }
        ]
      }
    };
  },
  created() {
    this.loadStatusItems();
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      return this.$moment(date).format("DD/MM/YYYY");
    },
    calculateDaysOld(date) {
      if (!date) return '';
      const reqDate = new Date(date);
      const today = new Date();
      const diffTime = Math.abs(today - reqDate);
      return Math.floor(diffTime / (1000 * 60 * 60 * 24));
    },
    getStatusColor(status) {
      return statusColor(status);
    },
    getDaysOldColor(date) {
      const days = this.calculateDaysOld(date);
      if (days <= 5) return "green darken-1";
      if (days <= 15) return "orange darken-2";
      return "red darken-1";
    },
    loadStatusItems() {
      _sDefinition.definitiongroup(1721, 0, this.$fun.getUserID())
        .then(response => {
          if (response.status === 200 && response.data) {
            this.statusItems = response.data.filter(item => item.DedValue !== 1);
          }
        })
        .catch(error => {
          console.error("Error loading status definitions:", error);
        });
    },
    validateFile(file) {
      if (!file) return;
      
      const allowedExtensions = ['zip', 'pdf', 'png', 'jpg', 'jpeg'];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (!allowedExtensions.includes(fileExtension)) {
        this.$fun.alert("Extensión de archivo no permitida. Solo se aceptan: .zip, .pdf, .png, .jpg, .jpeg", "warning");
        this.evidenceFile = null;
        return;
      }
      
      if (file.size > 10 * 1024 * 1024) {
        this.$fun.alert("El archivo supera el tamaño máximo permitido de 10MB", "warning");
        this.evidenceFile = null;
        return;
      }
    },
    clearForm() {
      this.evidenceFile = null;
      this.$nextTick(() => {
        setTimeout(() => {
          const usrID = this.$fun.getUserID();
          _sRequirementService.getUserDetail(usrID, usrID).then(response => {
            if (response.status === 200 && response.data) {
              const detail = response.data;
              this.$set(this.$refs.crud.row, 'ReqEmail', detail.UsrEmail);
              this.$set(this.$refs.crud.row, 'RequesterName', detail.PersonName);
              this.$set(this.$refs.crud.row, 'AreaName', detail.AreaName);
              this.$set(this.$refs.crud.row, 'GerenciaName', detail.GerenciaName);
              this.$set(this.$refs.crud.row, 'ReqSystemProcess', "");
              this.$set(this.$refs.crud.row, 'ReqDate', this.$moment().format("YYYY-MM-DD HH:mm:ss"));
              this.$set(this.$refs.crud.row, 'ReqStatus', 1); // Default to 'Nuevo'
              this.$set(this.$refs.crud.row, 'ReqEvidenceLink', "");
            }
          });
        }, 100);
      });
    },
    rowSelected(items) {
      if (items.length > 0) {
        const selected = items[0];
        this.selected = selected;
        if (selected.ReqEvidencePath) {
          this.evidenceFile = { name: selected.ReqEvidencePath };
        } else {
          this.evidenceFile = null;
        }
      }
    },
    openFile(file) {
      if (!file) return;
      const fileName = typeof file === 'string' ? file : (file.name || '');
      if (!fileName) return;

      _sRequirementService.download(fileName, this.$fun.getUserID()).then((r) => {
        if (r.status === 200) {
          this.$fun.downloadHttp(r);
        }       
      }).catch(error => {
        console.error(error);
        this.$fun.alert("El archivo no se encuentra disponible o no existe en el servidor.", "error");
      });
    },
    save(item) {
      if (!item.ReqEmail) {
        this.$fun.alert("Es obligatorio ingresar un correo de contacto", "warning");
        return;
      }

      if (!item.ReqType) {
        this.$fun.alert("Es obligatorio seleccionar un tipo de requerimiento", "warning");
        return;
      }

      if (!item.ReqTitle) {
        this.$fun.alert("Es obligatorio ingresar el título del requerimiento", "warning");
        return;
      }

      if (!item.ReqCurrentProblem) {
        this.$fun.alert("Es obligatorio detallar el problema actual o necesidad", "warning");
        return;
      }

      if (!item.ReqExpectedResult) {
        this.$fun.alert("Es obligatorio detallar el resultado esperado", "warning");
        return;
      }

      item.UsrCreateID = this.$fun.getUserID();
      item.UsrUpdateID = this.$fun.getUserID();
      item.ReqEvidencePath = this.evidenceFile != null ? this.evidenceFile.name : "";
      item.ReqEvidenceLink = item.ReqEvidenceLink || "";
      if (item.SecStatus == null) item.SecStatus = 1;

      const proceedToSave = () => {
        item.save();
      };

      if (this.evidenceFile instanceof File) {
        const formData = new FormData();
        formData.append("file", this.evidenceFile);

        _sRequirementService.upload(this.$fun.getUserID(), formData)
          .then(response => {
            if (response.status === 200) {
              console.log("Evidencia subida correctamente");
              proceedToSave();
            } else {
              this.$fun.alert("Error al subir el archivo, por favor intente nuevamente", "warning");
            }
          })
          .catch(error => {
            console.error(error);
            this.$fun.alert("Error al conectar con el servidor para subir el archivo", "error");
          });
      } else {
        proceedToSave();
      }
    }
  }
}
</script>

<style scoped>
.s-textarea-wrapper {
  position: relative;
  width: 100%;
  padding-top: -2px;
  margin-top: -2px;
}

.textarea-label {
  margin-bottom: 4px;
  display: block;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
}

.textarea-label b {
  font-weight: 600;
}

.theme--dark .textarea-label {
  color: rgba(255, 255, 255, 0.87);
}

.s-textarea-field >>> textarea {
  resize: vertical;
  overflow: auto;
  min-height: 60px;
}
</style>
